import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { Button, Icon, VisuallyHidden } from '@leagueplatform/genesis-core';

type UserBarProps = {
  label: string;
  isOpen: boolean;
  onClick: (event: any) => void;
};

export const UserBar = ({ label, isOpen, onClick, ...props }: UserBarProps) => {
  const { formatMessage } = useIntl();
  return (
    <Button
      id="user_dropdown_menu_button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      aria-controls="user_dropdown_menu"
      size="toolbar"
      priority="tertiary"
      css={{
        fontSize: '$bodyTwo',
        fontWeight: 500,
        borderRadius: '$none',
        border: '$none',
        span: { display: 'flex', alignItems: 'center' },
        '&:hover': {
          color: '$onSurfaceTextPrimary',
        },
      }}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    >
      {label}
      <VisuallyHidden>
        {formatMessage({ id: 'USER_DROPDOWN_BTN_LABEL' })}
      </VisuallyHidden>
      <Icon
        icon="interfaceChevronDown"
        size="$one"
        css={{
          marginLeft: '$quarter',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
          transition: 'transform 0.5s ease',
        }}
      />
    </Button>
  );
};
